// extracted by mini-css-extract-plugin
export default {"wrapper":"chip_wrapper__F4Nrp","gray":"chip_gray__LeoCU","clear__svg":"chip_clear__svg__lHeIL"};